import styles from "@/styles/default-layout.module.scss"
import React from "react"
import { useEffect } from 'react'
import Header from "./Header"
import Footer from "./Footer"
import { FloatButton } from 'antd'

interface LayoutProps {
  children: React.ReactNode;
}

export default function DefaultLayout(props: LayoutProps) {
  // 判断如果是移动端，将进行缩放（渲染一个1300px的pc网页，缩放到手机上展示）
  useEffect(() => {
    const targetWidth = 1300;
    const screenWidth = window.innerWidth;
    const scaleRatio = screenWidth / targetWidth;

    const adjustScale = () => {
        // 仅当屏幕宽度小于768px时执行
        if (screenWidth >= 768) return;

        const container = document.querySelector('#defaultLayout') as HTMLElement;
        if (container) {
            setTimeout(() => {
              // 等待页面布局稳定后再执行高度计算
                requestAnimationFrame(() => {
                  const originalHeight = container.offsetHeight;
                  container.style.width = `${targetWidth}px`;
                  container.style.transform = `scale(${scaleRatio})`;
                  container.style.transformOrigin = 'top left';

                  // 确保高度不小于当前屏幕高度
                  const scaledHeight = originalHeight * scaleRatio;
                  const screenHeight = window.innerHeight;
                  container.style.height = `${Math.max(scaledHeight, screenHeight)}px`;
              });
            }, 800);
        }
    };

    adjustScale(); // 初始执行
  }, []);

  return (
    <div id="defaultLayout" className={styles['default-layout']}>
      <main style={{ background: '#FFFFFF', position: 'relative' }}>
        <Header></Header>
        {props.children}
      </main>

      <Footer></Footer>

      <FloatButton.BackTop />
    </div>
  )
}